/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./dx-base-cell-render.component";
var styles_DxBaseCellRenderComponent = [];
var RenderType_DxBaseCellRenderComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_DxBaseCellRenderComponent, data: {} });
export { RenderType_DxBaseCellRenderComponent as RenderType_DxBaseCellRenderComponent };
export function View_DxBaseCellRenderComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_DxBaseCellRenderComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "dx-base-cell-render", [], null, null, null, View_DxBaseCellRenderComponent_0, RenderType_DxBaseCellRenderComponent)), i0.ɵdid(1, 180224, null, 0, i1.DxBaseCellRenderComponent, [], null, null)], null, null); }
var DxBaseCellRenderComponentNgFactory = i0.ɵccf("dx-base-cell-render", i1.DxBaseCellRenderComponent, View_DxBaseCellRenderComponent_Host_0, {}, {}, []);
export { DxBaseCellRenderComponentNgFactory as DxBaseCellRenderComponentNgFactory };
